import React, { FunctionComponent } from 'react';
import { financial } from 'data';
import { Button, Icon, Markdown, Row, Text, WizardIntroCard } from 'mymoria-ui/components';
import { WizardComponentProps } from 'react-albus';
import { sprintf } from 'utils';
import { formatPrice } from 'helpers';
import { useHDHState } from './HDHState';

const IntroStep: FunctionComponent<WizardComponentProps> = ({ wizard: { push } }) => {
  const [{ totalFuturePrice }] = useHDHState();

  return (
    <WizardIntroCard>
      <Markdown>
        {sprintf(financial.hdh.intro.description, {
          totalFuturePrice: formatPrice(totalFuturePrice),
        })}
      </Markdown>
      <Row justifyContent="center" alignItems="center" p={4}>
        <Icon.Duration />
        <Text ml={1} fontWeight="bold">
          {financial.hdh.intro.estimatedTime}
        </Text>
      </Row>
      <Button onClick={() => push('paymentType')}>{financial.hdh.intro.next}</Button>
    </WizardIntroCard>
  );
};

export default IntroStep;
